var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7188 18.5469L14.7344 1.48438C13.9375 0.171875 12.0156 0.171875 11.2656 1.48438L1.23438 18.5469C0.484375 19.8594 1.42188 21.5 2.96875 21.5H22.9844C24.5312 21.5 25.4688 19.8594 24.7188 18.5469ZM11.875 6.875C11.875 6.26562 12.3438 5.75 13 5.75C13.6094 5.75 14.125 6.26562 14.125 6.875V12.875C14.125 13.5312 13.6094 14 13 14C12.4375 14 11.875 13.5312 11.875 12.875V6.875ZM13 18.5C12.1562 18.5 11.5 17.8438 11.5 17.0469C11.5 16.25 12.1562 15.5938 13 15.5938C13.7969 15.5938 14.4531 16.25 14.4531 17.0469C14.4531 17.8438 13.7969 18.5 13 18.5Z",
    fill: "#FF7B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangle);
export default __webpack_public_path__ + "static/media/exclamation-triangle.9e4cde33f7005bc23f8dfbc958bd1653.svg";
export { ForwardRef as ReactComponent };